import { UNIFIED_COPILOT_AGENT_ID } from "src/api/agents/unifiedCopilot";
import { useCopilotPrewarm } from "src/copilot/useCopilotPrewarm";
import { UnifiedCopilotChatSessionContext } from "src/unifiedCopilot/chat/UnifiedCopilotChatSessionContext";
import { useUnifiedCopilotChatSessionState } from "src/unifiedCopilot/chat/useUnifiedCopilotChatSession";

type UnifiedCopilotChatSessionProviderProps = {
  children: React.ReactNode;
  userId: string;
  workspaceId: string;
};

export const UnifiedCopilotChatSessionProvider: React.FC<
  UnifiedCopilotChatSessionProviderProps
> = ({ children, userId, workspaceId }) => {
  const session = useUnifiedCopilotChatSessionState({ userId, workspaceId });

  // This provider mounts once per workspace, above the router outlet, so the
  // ping goes out on workspace load and the container is warm before the user
  // opens the copilot on any page.
  useCopilotPrewarm({
    agentId: UNIFIED_COPILOT_AGENT_ID,
    sessionId: session.sessionId,
    enabled: true,
    api: "copilot-v2",
    keepAlive: true,
  });

  // Once the current session is in use it can no longer serve a second,
  // parallel conversation, so the session reserved for the next one gets its
  // own container.
  useCopilotPrewarm({
    agentId: UNIFIED_COPILOT_AGENT_ID,
    sessionId: session.nextSessionId,
    enabled: session.nextSessionId !== null,
    api: "copilot-v2",
    keepAlive: true,
  });

  return (
    <UnifiedCopilotChatSessionContext value={session}>
      {children}
    </UnifiedCopilotChatSessionContext>
  );
};
